import { render, staticRenderFns } from "./PayPalButtons.vue?vue&type=template&id=1d585b1c"
import script from "./PayPalButtons.vue?vue&type=script&lang=ts"
export * from "./PayPalButtons.vue?vue&type=script&lang=ts"
import style0 from "./PayPalButtons.vue?vue&type=style&index=0&id=1d585b1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports